import React from 'react';
import "./App.css";
import AppRoutes from "./routes";
import "./assets/styles/main.scss";
import HeadTag from "./setting/headTag";  

const App = () => {
  return (
    <>
      <HeadTag />
      <AppRoutes />
    </>
  );
};

export default App;
